export enum NotificationType {
  INFO = "SCHEMA INFO",
  WARNING = "SCHEMA WARNING",
  ERROR = "CONTAINER ERROR",
  ALERT = "CONTAINER ALERT",
}